<page-headline
    [linkTitle]="'Performance'"
    [module]="'performance'"
    [moduleIcon]="'fa-heartbeat'"
    [moduleLink]="'performance'"
    [pageTitle]="'Branch Projections'"
>
</page-headline>

<div [ngClass]="{ 'middle-layer-for-page-disable': showSuccessfulSubmitMessage }"></div>

<successful-submission-dialog
    *ngIf="showSuccessfulSubmitMessage"
    (keydown)="onKeydown($event)"
    (editClickedAfterSuccess)="editClickedAfterSuccess()"
    (viewClickedAfterSuccess)="viewClickedAfterSuccess()"
    (topRightXClickedAfterSuccess)="topRightXClickedAfterSuccess()"
    title="{{ yearOption }} Projections Saved"
    message="Congratulations! You're on your way to another productive year. All projection edits must be submitted by {{
        closingDate | date: 'shortDate'
    }}."
>
</successful-submission-dialog>

<div class="row-layout-track-left-align">
    <div class="branch-ddl">
        <angular2-multiselect
            [data]="branchesOfInterest"
            [(ngModel)]="selectedIdentifier"
            [settings]="branchListSettings"
            (onSelect)="onBranchChange($event)"
        >
        </angular2-multiselect>
    </div>

    <div class="branch-ddl">
        <angular2-multiselect
            [data]="yearsOfInterest"
            [(ngModel)]="selectedYear"
            [settings]="yearListSettings"
            (onSelect)="onYearChange($event)"
            style="margin-left: 24px; position: relative; top: -19.5px"
        >
        </angular2-multiselect>
    </div>
</div>

<div style="clear: left">
    <mat-card
        class="large-card"
        style="height: 617px; width: 680px"
        *ngIf="noProjections && !addProjections"
    >
        <div
            style="width: auto"
            *ngIf="
                projectionsAreOpen && !loading && branchesOfInterest && branchesOfInterest.length
            "
        >
            <div id="noProjectionsText">
                You have not added your {{ selectedYear[0].year }} projections yet.
            </div>
            <div id="noProjectionsSubText">
                Your annual projections must be submitted by midnight on
                {{ closingDate | date: 'MM/dd/yyyy':'UTC' }}.
            </div>
            <div id="addProjectionsButtonsDiv">
                <button
                    mat-stroked-button
                    primary
                    class="btn-button"
                    (click)="addProjectionsClicked()"
                    type="button"
                    style="margin-left: 24px"
                >
                    ADD PROJECTIONS
                </button>
            </div>
        </div>
        <div
            style="width: 100%"
            *ngIf="
                !loading &&
                !this.projectionsAreOpen &&
                branchesOfInterest &&
                branchesOfInterest.length
            "
        >
            <div id="noProjectionsText" *ngIf="showProjectionsAreNotOpenYetMessage()">
                {{ selectedYear[0].year }} projections will not open until
                {{ openDate | date: 'MM/dd/yyyy':'UTC' }}.
            </div>
            <div
                id="noProjectionsText"
                *ngIf="
                    !showProjectionsAreNotOpenYetMessage() &&
                    showProjectionsAreAlreadyClosedMessage() &&
                    branchesOfInterest &&
                    branchesOfInterest.length > 0
                "
            >
                {{ selectedYear[0].year }} projections were not submitted and it's past the open
                period.
            </div>
        </div>
        <div style="width: 100%" *ngIf="loading">
            <div id="noProjectionsText" *ngIf="loading">
                <spin-loader [type]="'spinner'" style="height: 100%; margin-top: 40%"></spin-loader>
            </div>
        </div>
        <div style="width: 100%" *ngIf="!loading">
            <div
                id="noProjectionsText"
                *ngIf="!branchesOfInterest || branchesOfInterest.length === 0"
            >
                Unfortunately, we could not find any branches of interest for this user.
            </div>
        </div>
    </mat-card>
    <mat-card
        class="large-card"
        *ngIf="
            (!(noProjections && projectionsAreOpen) || addProjections) &&
            !(!projectionsAreOpen && noProjections && !addProjections)
        "
    >
        <p id="page-title">{{ selectedYear[0].year }} Projections</p>
        <div *ngIf="!loading && showNoProjectionsMessage()" style="padding-bottom: 500px">
            This branch did not submit projections for
            {{ selectedYear[0].year }}.
        </div>
        <div *ngIf="!showNoProjectionsMessage()">
            <p
                id="page-sub-title"
                *ngIf="
                    branchIdentifier &&
                    !showEmployeeProjections &&
                    projectionsAreEditable &&
                    projectionsAreOpen
                "
            >
                Enter your branch’s annual projections in the fields below. Your monthly averages
                and overall goals will automatically populate based on your inputs.
            </p>
            <form [formGroup]="branchProjectionForm" (ngSubmit)="onSubmit()">
                <div
                    id="sections"
                    *ngIf="
                        !showEmployeeProjections &&
                        branchIdentifier &&
                        projectionsAreEditable &&
                        projectionsAreOpen
                    "
                    formGroupName="branchProjections"
                >
                    <div id="section-projections">
                        <p class="section-title">Your {{ selectedYear[0].year }} Projections</p>
                        <div class="projection-item">
                            <span class="projection-item-title">Total Loans</span>
                            <div>
                                <input
                                    type="text"
                                    class="projection-input"
                                    style="width: 46px"
                                    formControlName="totalLoans"
                                    digitOnly
                                />
                                <span class="projection-text-current" *ngIf="data.loans.current">
                                    {{ statDescription }}
                                    <strong> {{ data.loans.current }} </strong>.
                                </span>
                                <span class="projection-text" *ngIf="data.loans.projection"
                                    >Your 2019 projection is
                                    <strong>{{ data.loans.projection }}</strong
                                    >.</span
                                >
                                <div *ngIf="totalLoans.errors && totalLoans.touched" class="errors">
                                    <ul>
                                        <li *ngIf="totalLoans.errors.required">Required</li>
                                        <li *ngIf="totalLoans.errors.max && totalLoans.dirty">
                                            Value must be &le;
                                            {{ totalLoans.errors.max.max }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="projection-item">
                            <span class="projection-item-title">Total Volume</span>
                            <div>
                                <input
                                    class="projection-input"
                                    style="width: 120px"
                                    formControlName="totalVolume"
                                    digitOnly
                                    currencyMask
                                    [options]="{
                                        prefix: '$',
                                        precision: 0,
                                        align: 'left'
                                    }"
                                />
                                <span class="projection-text-current" *ngIf="data.volume.current"
                                    >{{ statDescription }}
                                    <strong>{{
                                        data.volume.current | currency: 'USD':'symbol':'1.0-0'
                                    }}</strong
                                    >.</span
                                >
                                <span class="projection-text" *ngIf="data.volume.projection">
                                    Your 2019 projection is
                                    <strong>{{
                                        data.volume.projection | currency: 'USD':'symbol':'1.0-0'
                                    }}</strong
                                    >.</span
                                >
                                <div
                                    *ngIf="totalVolume.errors && totalVolume.touched"
                                    class="errors"
                                >
                                    <ul>
                                        <li *ngIf="totalVolume.errors.required">Required</li>
                                        <li *ngIf="totalVolume.errors.max && totalVolume.dirty">
                                            Value must be &le;
                                            {{ totalVolume.errors.max.max }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="projection-item">
                            <span class="projection-item-title">Purchase Mix (%)</span>
                            <div>
                                <input
                                    type="text"
                                    class="projection-input"
                                    style="width: 46px"
                                    formControlName="purchaseMix"
                                    digitOnly
                                />
                                <span class="projection-text-current" *ngIf="data.volume.current"
                                    >{{ statDescription }}
                                    <strong>{{ data.purchase.current }}%</strong></span
                                >
                                <div
                                    *ngIf="purchaseMix.errors && purchaseMix.touched"
                                    class="errors"
                                >
                                    <ul>
                                        <li *ngIf="purchaseMix.errors.required">Required</li>
                                        <li *ngIf="purchaseMix.errors.max && purchaseMix.dirty">
                                            Value (%) must be &le;
                                            {{ purchaseMix.errors.max.max }}%
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="projection-item">
                            <span class="projection-item-title">Government Mix (%)</span>
                            <div>
                                <input
                                    type="text"
                                    class="projection-input"
                                    style="width: 46px"
                                    formControlName="governmentMix"
                                    digitOnly
                                />
                                <span class="projection-text-current" *ngIf="data.volume.current"
                                    >{{ statDescription }}
                                    <strong>{{ data.government.current }}%</strong></span
                                >
                                <div
                                    *ngIf="governmentMix.errors && governmentMix.touched"
                                    class="errors"
                                >
                                    <ul>
                                        <li *ngIf="governmentMix.errors.required">Required</li>
                                        <li *ngIf="governmentMix.errors.max && governmentMix.dirty">
                                            Value must be &le;
                                            {{ governmentMix.errors.max.max }}%
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="projection-item">
                            <span class="projection-item-title">Tenured Producers (FT)</span>
                            <div>
                                <input
                                    type="text"
                                    class="projection-input"
                                    style="width: 46px"
                                    formControlName="tenuredProducers"
                                    digitOnly
                                />
                                <span class="projection-text-current" *ngIf="data.tenured.current">
                                    {{ statDescription }}
                                    <strong> {{ data.tenured.current }} </strong>.
                                </span>
                                <div
                                    *ngIf="tenuredProducers.errors && tenuredProducers.touched"
                                    class="errors"
                                >
                                    <ul>
                                        <li *ngIf="tenuredProducers.errors.required">Required</li>
                                        <li
                                            *ngIf="
                                                tenuredProducers.errors.max &&
                                                tenuredProducers.dirty
                                            "
                                        >
                                            Value must be &le;
                                            {{ tenuredProducers.errors.max.max }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="section-goals">
                        <p class="section-title">Your {{ selectedYear[0].year }} Goals</p>
                        <div id="goals-box" *ngIf="unitsPerMonth.value && totalMonthlyVolume.value">
                            <div class="goal-item" *ngIf="unitsPerMonth.value">
                                <span class="goal-data">{{ unitsPerMonth.value }} </span>
                                <span class="goal-text"><strong>units</strong> per month</span>
                            </div>

                            <div class="goal-item" *ngIf="avgLoanAmount.value">
                                <span class="goal-text"
                                    >with an <strong>average loan amount</strong> of
                                </span>
                                <span class="goal-data">{{
                                    avgLoanAmount.value | currency: 'USD':'symbol':'1.0-0'
                                }}</span>
                            </div>

                            <div class="goal-item" *ngIf="totalMonthlyVolume.value">
                                <span class="goal-text"
                                    >and a total monthly <strong>volume</strong> averaging
                                </span>
                                <span class="goal-data">{{
                                    totalMonthlyVolume.value | currency: 'USD':'symbol':'1.0-0'
                                }}</span>
                            </div>

                            <div class="goal-item" *ngIf="purchaseVolume.value">
                                <span class="goal-data"
                                    >{{ purchaseVolume.value | currency: 'USD':'symbol':'1.0-0' }}
                                </span>
                                <span class="goal-text">in <strong>purchase</strong> volume</span>
                            </div>

                            <div class="goal-item" *ngIf="purchaseMix.value">
                                <span class="goal-text">and&nbsp;</span>
                                <span class="goal-data">{{
                                    totalVolume.value - purchaseVolume.value
                                        | currency: 'USD':'symbol':'1.0-0'
                                }}</span>
                                <span class="goal-text"
                                    >&nbsp;in <strong>refi/other</strong> volume</span
                                >
                            </div>

                            <div class="goal-item" *ngIf="governmentVolume.value">
                                <span class="goal-data"
                                    >{{ governmentVolume.value | currency: 'USD':'symbol':'1.0-0' }}
                                </span>
                                <span class="goal-text">in <strong>government</strong> volume</span>
                            </div>

                            <div class="goal-item" *ngIf="governmentMix.value">
                                <span class="goal-text">and&nbsp;</span>
                                <span class="goal-data">{{
                                    totalVolume.value - governmentVolume.value
                                        | currency: 'USD':'symbol':'1.0-0'
                                }}</span>
                                <span class="goal-text"
                                    >&nbsp;in <strong>conv/other</strong> volume</span
                                >
                            </div>

                            <div class="goal-item" *ngIf="tenuredProducers.value">
                                <span class="goal-data">{{ tenuredProducers.value }} </span>
                                <span class="goal-text">FT <strong>tenured producers</strong></span>
                            </div>

                            <div
                                class="goal-item"
                                *ngIf="tenuredProducers.value && unitsPerProducer.value"
                            >
                                <span class="goal-text">averaging </span>
                                <span class="goal-data">{{ unitsPerProducer.value }} </span>
                                <span class="goal-text"
                                    ><strong>units</strong> monthly per producer</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="showEmployeeProjections || !projectionsAreEditable">
                    <div id="branch-projection-summary">
                        <span class="projection-value">
                            {{ totalLoans.value | number: '1.0-0' }}
                        </span>
                        <span class="projection-label"> Loans </span>
                        <span class="projection-value" style="padding-left: 21px">
                            {{ totalVolume.value | currency: 'USD':'symbol':'1.0-0' }}
                        </span>
                        <span class="projection-label"> Volume </span>
                        <span class="projection-value" style="padding-left: 21px">
                            {{ purchaseMix.value }}%
                        </span>
                        <span class="projection-label"> Purchases </span>
                        <span class="projection-value" style="padding-left: 21px">
                            {{ purchaseVolume.value | currency: 'USD':'symbol':'1.0-0' }}
                        </span>
                        <span class="projection-label"> Purchase Volume </span>
                        <span class="projection-value" style="padding-left: 21px">
                            {{ governmentMix.value }}%
                        </span>
                        <span class="projection-label"> Government </span>
                        <span class="projection-value" style="padding-left: 21px">
                            {{ governmentVolume.value | currency: 'USD':'symbol':'1.0-0' }}
                        </span>
                        <span class="projection-label"> Government Volume </span>
                        <span
                            *ngIf="projectionsAreOpen"
                            style="padding-left: 20px; color: #0078d7; cursor: pointer"
                            (click)="editBranchProjectionsClicked()"
                        >
                            Edit Branch Projections
                        </span>
                        <span
                            *ngIf="
                                employeeMonthlyProjections.length &&
                                !projectionsAreBeingEdited &&
                                projectionsAreOpen &&
                                selectedYear[0].year == yearProjectionsAreOpen
                            "
                            style="padding-left: 20px; color: #0078d7; cursor: pointer"
                            (click)="editEmployeeProjectionsClicked()"
                        >
                            Edit Employee Projections
                        </span>
                    </div>
                    <div id="employee-projection-grid">
                        <table class="employee-projection-table">
                            <thead>
                                <tr class="header">
                                    <td style="padding-left: 10px">PRODUCER DETAILS</td>
                                    <td class="employee-projection-header">JAN</td>
                                    <td class="employee-projection-header">FEB</td>
                                    <td class="employee-projection-header">MAR</td>
                                    <td class="employee-projection-header">APR</td>
                                    <td class="employee-projection-header">MAY</td>
                                    <td class="employee-projection-header">JUN</td>
                                    <td class="employee-projection-header">JUL</td>
                                    <td class="employee-projection-header">AUG</td>
                                    <td class="employee-projection-header">SEP</td>
                                    <td class="employee-projection-header">OCT</td>
                                    <td class="employee-projection-header">NOV</td>
                                    <td class="employee-projection-header">DEC</td>
                                    <td class="employee-projection-header">TOTAL</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="seasonality-row">
                                    <td id="seasonality-cell">Seasonality Curve</td>
                                    <td *ngFor="let monthPercentage of seasonalityCurve">
                                        {{ monthPercentage / 10 }}%
                                    </td>
                                    <td>100%</td>
                                </tr>
                                <ng-container
                                    formArrayName="employeeProjections"
                                    *ngFor="
                                        let employeeProjection of employeeProjections;
                                        let i = index
                                    "
                                >
                                    <tr [formGroupName]="i" class="employee-projection-row">
                                        <td class="producer-details-container-td">
                                            <table class="producer-details-table">
                                                <tr>
                                                    <td style="text-align: left">
                                                        <span style="font-weight: bold">
                                                            {{ employeeYTDStats[i]?.name }} </span
                                                        >&nbsp;-&nbsp;{{
                                                            employeeYTDStats[i]?.termMo
                                                                ? 'Terminated in ' +
                                                                  reusableFunctions.getMonthName(
                                                                      employeeYTDStats[i]?.termMo
                                                                  ).shortMonth
                                                                : employeeYTDStats[i]?.isTenured
                                                                ? 'Tenured'
                                                                : employeeYTDStats[i]?.tenureMo
                                                                ? 'Tenures in ' +
                                                                  reusableFunctions.getMonthName(
                                                                      employeeYTDStats[i]?.tenureMo
                                                                  ).shortMonth
                                                                : ''
                                                        }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="padding: 0px !important">
                                                        <table
                                                            class="producer-details-inner-table"
                                                            style="height: 40px !important"
                                                        >
                                                            <tr>
                                                                <td
                                                                    class="producer-details-label-td"
                                                                >
                                                                    Avg Units
                                                                </td>
                                                                <td
                                                                    class="producer-details-label-td"
                                                                >
                                                                    Avg LA
                                                                </td>
                                                                <td
                                                                    class="producer-details-label-td"
                                                                >
                                                                    Avg Vol
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td
                                                                    class="producer-details-value-td"
                                                                >
                                                                    {{
                                                                        employeeYTDStats[i]
                                                                            ?.avgFundedUnits
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="producer-details-value-td"
                                                                >
                                                                    {{
                                                                        employeeYTDStats[i]
                                                                            ?.avgLoanAmount
                                                                            | currency
                                                                                : 'USD'
                                                                                : 'symbol'
                                                                                : '1.0-0'
                                                                    }}
                                                                </td>
                                                                <td
                                                                    class="producer-details-value-td"
                                                                >
                                                                    {{
                                                                        employeeYTDStats[i]
                                                                            ?.avgFundedVol
                                                                            | currency
                                                                                : 'USD'
                                                                                : 'symbol'
                                                                                : '1.0-0'
                                                                    }}
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                        <ng-container *ngIf="employeeMonthlyProjections.length > 0">
                                            <td
                                                class="employee-projection-cell"
                                                *ngFor="
                                                    let monthProj of employeeMonthlyProjections[i]
                                                        .monthlyProjections;
                                                    let j = index
                                                "
                                            >
                                                <table class="producer-details-table">
                                                    <tr class="producer-values-table-tr">
                                                        <td class="producer-monthly-units-td">
                                                            <span>{{ monthProj.units }}</span>
                                                        </td>
                                                    </tr>
                                                    <tr class="producer-values-table-tr">
                                                        <td class="producer-monthly-volume-td">
                                                            <span>{{
                                                                monthProj.volume
                                                                    | currency
                                                                        : 'USD'
                                                                        : 'symbol'
                                                                        : '1.0-0'
                                                            }}</span>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </ng-container>
                                        <td>
                                            <table class="producer-details-table">
                                                <tr class="producer-values-table-tr">
                                                    <td style="position: relative; top: -6px">
                                                        <input
                                                            *ngIf="
                                                                projectionsAreEditable &&
                                                                projectionsAreOpen
                                                            "
                                                            type="text"
                                                            class="employee-projection-input"
                                                            style="width: 115px"
                                                            formControlName="totalEmployeeUnits"
                                                            digitOnly
                                                        />
                                                        <span
                                                            *ngIf="
                                                                !projectionsAreEditable &&
                                                                employeeProjections[i].get(
                                                                    'totalEmployeeUnits'
                                                                )
                                                            "
                                                            class="non-editable-total"
                                                            style="position: relative; top: -7px"
                                                        >
                                                            {{
                                                                employeeProjections[i].get(
                                                                    'totalEmployeeUnits'
                                                                ).value
                                                            }}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <ng-container
                                                    *ngIf="
                                                        getEmployeeUnitsControl(i) &&
                                                        getEmployeeUnitsControl(i).errors &&
                                                        getEmployeeUnitsControl(i).dirty &&
                                                        getEmployeeUnitsControl(i).touched
                                                    "
                                                >
                                                    <tr
                                                        *ngIf="
                                                            getEmployeeUnitsControl(i).errors.max
                                                        "
                                                        class="errors"
                                                    >
                                                        Units must be &le;
                                                        {{
                                                            getEmployeeUnitsControl(i).errors.max
                                                                .max
                                                        }}.
                                                    </tr>
                                                    <tr
                                                        *ngIf="
                                                            getEmployeeUnitsControl(i).errors
                                                                .required
                                                        "
                                                        class="errors"
                                                    >
                                                        Units are required.
                                                    </tr>
                                                </ng-container>
                                                <tr class="producer-values-table-tr">
                                                    <td style="position: relative; top: -6px">
                                                        <input
                                                            *ngIf="
                                                                projectionsAreEditable &&
                                                                projectionsAreOpen
                                                            "
                                                            class="employee-projection-input"
                                                            style="width: 115px"
                                                            formControlName="totalEmployeeVolume"
                                                            digitOnly
                                                            currencyMask
                                                            [options]="{
                                                                prefix: '$',
                                                                precision: 0,
                                                                align: 'right'
                                                            }"
                                                        />
                                                        <span
                                                            *ngIf="
                                                                !projectionsAreEditable &&
                                                                employeeProjections[i].get(
                                                                    'totalEmployeeVolume'
                                                                )
                                                            "
                                                            class="non-editable-total"
                                                            style="position: relative; top: 16px"
                                                        >
                                                            {{
                                                                employeeProjections[i].get(
                                                                    'totalEmployeeVolume'
                                                                ).value
                                                                    | currency
                                                                        : 'USD'
                                                                        : 'symbol'
                                                                        : '1.0-0'
                                                            }}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <ng-container
                                                    *ngIf="
                                                        getEmployeeVolumeControl(i) &&
                                                        getEmployeeVolumeControl(i).errors &&
                                                        getEmployeeVolumeControl(i).dirty &&
                                                        getEmployeeVolumeControl(i).touched
                                                    "
                                                >
                                                    <tr
                                                        *ngIf="
                                                            getEmployeeVolumeControl(i).errors.max
                                                        "
                                                        class="errors"
                                                    >
                                                        Volume must be &le;
                                                        {{
                                                            getEmployeeVolumeControl(i).errors.max
                                                                .max
                                                                | currency: 'USD':'symbol':'1.0-0'
                                                        }}.
                                                    </tr>
                                                    <tr
                                                        *ngIf="
                                                            getEmployeeVolumeControl(i).errors
                                                                .required
                                                        "
                                                        class="errors"
                                                    >
                                                        Volume is required.
                                                    </tr>
                                                </ng-container>
                                            </table>
                                        </td>
                                    </tr>
                                </ng-container>
                                <tr class="employee-projection-row projection-totals">
                                    <td style="padding: 16px 0px">
                                        <table class="producer-details-table">
                                            <tr class="producer-values-table-tr">
                                                <td
                                                    class="producer-monthly-units-td"
                                                    style="text-align: left"
                                                >
                                                    <b>Total Units</b>
                                                </td>
                                            </tr>
                                            <tr class="producer-values-table-tr">
                                                <td
                                                    class="producer-monthly-volume-td"
                                                    style="text-align: left"
                                                >
                                                    <b>Total Volume</b>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td
                                        *ngFor="
                                            let thisMonthUnits of totalMonthlyProjections.monthlyUnits;
                                            let i = index
                                        "
                                    >
                                        <table class="producer-details-table">
                                            <tr class="producer-values-table-tr">
                                                <td class="producer-monthly-units-td">
                                                    <b>{{ thisMonthUnits | number: '1.0-0' }}</b>
                                                </td>
                                            </tr>
                                            <tr class="producer-values-table-tr">
                                                <td class="producer-monthly-volume-td">
                                                    <b>{{
                                                        totalMonthlyProjections.monthlyVolume[i]
                                                            | currency: 'USD':'symbol':'1.0-0'
                                                    }}</b>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td>
                                        <table class="producer-details-table">
                                            <tr class="producer-values-table-tr">
                                                <td class="producer-monthly-units-td">
                                                    <b>{{ totalUnits | number: '1.0-0' }}</b>
                                                </td>
                                            </tr>
                                            <tr class="producer-values-table-tr">
                                                <td class="producer-monthly-volume-td">
                                                    <b>{{
                                                        totalVol | currency: 'USD':'symbol':'1.0-0'
                                                    }}</b>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr class="employee-projection-row projection-agg-totals">
                                    <td class="producer-details-container-td">
                                        <table class="producer-details-table">
                                            <tr>
                                                <td style="text-align: left">
                                                    <span style="font-weight: bold"
                                                        >Shrink/Stretch</span
                                                    >
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <table
                                                        class="producer-details-inner-table"
                                                        style="height: 40px !important"
                                                    >
                                                        <tr>
                                                            <td
                                                                class="producer-details-label-td"
                                                            ></td>
                                                            <td
                                                                class="producer-details-label-td"
                                                            ></td>
                                                            <td
                                                                class="producer-details-label-td"
                                                            ></td>
                                                        </tr>
                                                        <tr>
                                                            <td
                                                                class="producer-details-value-td"
                                                            ></td>
                                                            <td
                                                                class="producer-details-value-td"
                                                            ></td>
                                                            <td
                                                                class="producer-details-value-td"
                                                            ></td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td
                                        class="employee-projection-cell"
                                        *ngFor="
                                            let month of monthlyShrinkStretchUnits;
                                            let i = index
                                        "
                                    >
                                        <table class="producer-details-table">
                                            <tr class="producer-values-table-tr">
                                                <td class="producer-monthly-units-td">
                                                    {{ monthlyShrinkStretchUnits[i] }}
                                                </td>
                                            </tr>
                                            <tr class="producer-values-table-tr">
                                                <td class="producer-monthly-volume-td">
                                                    {{
                                                        monthlyShrinkStretchVol[i]
                                                            | currency: 'USD':'symbol':'1.0-0'
                                                    }}
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td class="employee-projection-cell">
                                        <table class="producer-details-table">
                                            <tr class="producer-values-table-tr">
                                                <td class="producer-monthly-units-td">
                                                    <b>{{ shrinkStretchUnits.value }}</b>
                                                </td>
                                            </tr>
                                            <tr class="producer-values-table-tr">
                                                <td class="producer-monthly-volume-td">
                                                    <b>{{
                                                        shrinkStretchVolume.value
                                                            | currency: 'USD':'symbol':'1.0-0'
                                                    }}</b>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr class="employee-projection-row">
                                    <td style="padding: 16px 0px">
                                        <table class="producer-details-table">
                                            <tr class="producer-values-table-tr">
                                                <td
                                                    class="producer-monthly-units-td"
                                                    style="text-align: left"
                                                >
                                                    <b>Adjusted Units</b>
                                                </td>
                                            </tr>
                                            <tr class="producer-values-table-tr">
                                                <td
                                                    class="producer-monthly-volume-td"
                                                    style="text-align: left"
                                                >
                                                    <b>Adjusted Volume</b>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td
                                        *ngFor="
                                            let thisMonthUnits of adjustedMonthlyProjections.monthlyUnits;
                                            let i = index
                                        "
                                    >
                                        <table class="producer-details-table">
                                            <tr class="producer-values-table-tr">
                                                <td class="producer-monthly-units-td">
                                                    <b>{{ thisMonthUnits | number: '1.0-0' }}</b>
                                                </td>
                                            </tr>
                                            <tr class="producer-values-table-tr">
                                                <td class="producer-monthly-volume-td">
                                                    <b>{{
                                                        adjustedMonthlyProjections.monthlyVolume[i]
                                                            | currency: 'USD':'symbol':'1.0-0'
                                                    }}</b>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td>
                                        <table class="producer-details-table">
                                            <tr class="producer-values-table-tr">
                                                <td class="producer-monthly-units-td">
                                                    <b>{{ totalLoans.value | number: '1.0-0' }}</b>
                                                </td>
                                            </tr>
                                            <tr class="producer-values-table-tr">
                                                <td class="producer-monthly-volume-td">
                                                    <b>{{
                                                        totalVolume.value
                                                            | currency: 'USD':'symbol':'1.0-0'
                                                    }}</b>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <div
                    id="btn-controls"
                    *ngIf="branchIdentifier && projectionsAreEditable && projectionsAreOpen"
                >
                    <div id="section-controls">
                        <button
                            mat-stroked-button
                            class="btn-button"
                            type="button"
                            *ngIf="
                                !(
                                    !branchProjectionForm.dirty ||
                                    (!showEmployeeProjections && !branchProjections.valid) ||
                                    (showEmployeeProjections && anyEmployeeProjectionIsInvalid())
                                )
                            "
                            (click)="discardClicked()"
                        >
                            DISCARD CHANGES
                        </button>
                        <button
                            *ngIf="!showEmployeeProjections"
                            mat-stroked-button
                            primary
                            class="btn-button"
                            [disabled]="!branchProjections.valid"
                            (click)="nextClicked()"
                            type="button"
                        >
                            Next
                        </button>
                        <button
                            *ngIf="showEmployeeProjections"
                            mat-stroked-button
                            primary
                            class="btn-button"
                            [disabled]="
                                !branchProjectionForm.dirty ||
                                (!showEmployeeProjections && !branchProjections.valid) ||
                                (showEmployeeProjections && anyEmployeeProjectionIsInvalid())
                            "
                            type="submit"
                        >
                            Submit
                            <i class="fa fa-spinner fa-spin" *ngIf="submitLoading"></i>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </mat-card>
</div>
